export default "__VITE_ASSET__HFWJHcB7__"